module.exports = __webpack_public_path__ + "static/media/cameras.17abf9d2.png";